export default __webpack_public_path__ + "assets/data-processing-agreement.670aa6bfcaf67f0afb712c1df6cceac9.pdf";